import { Box } from "@mui/material"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import CheckBoxGroupField from "src/components/atom/CheckBoxGroupField"
import { OutlinedButton } from "src/components/buttons/OutlinedButton"
import { useLoginContext } from "src/hooks/useLoginContext"
import { EVENT_MODAL_TYPE, EVENT_STATUS } from "src/modules/const"
import { Event } from "src/openapi"
import { PublishModal } from "./PublishModal"

interface Props {
  item?: Event
  creating?: boolean
  handleCreate?: any
  handleDraft?: any
  handleSave?: any
  handleDraftPublic?: any
  handlePublic?: any
  handleRemove?: any
  handleArchive?: any
  category?: number
  handleCategory: any
}

export const PublishPanelItem = ({
  item,
  creating,
  handleCreate,
  handleDraft,
  handleSave,
  handleDraftPublic,
  category,
  handleCategory,
  handlePublic,
  handleRemove,
  handleArchive,
}: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "mypage.event" })

  const { eventCategories } = useLoginContext()

  const [type, setType] = useState<number>()
  const [showModal, setShowModal] = useState<boolean>(false)

  return (
    <Box>
      <CheckBoxGroupField
        radio
        disabled={item?.status === EVENT_STATUS.ARCHIVED}
        name={t("category")}
        nameSize={14}
        datas={eventCategories}
        labelSize={14}
        lineSpace={0.5}
        selected={category}
        handleSelected={handleCategory}
        sx={{ ml: "30px", mt: "20px", mb: "20px" }}
        labelStyle={{ fontFamily: "Noto Sans JP !important;" }}
      />

      {creating ? (
        <>
          <OutlinedButton
            className="notosans"
            caption={t("create_event")}
            onClick={() => handleCreate()}
            sx={{
              width: "170px",
              height: "34px",
              ml: "20px",
              my: "5px",
              color: "primaryMain",
              borderColor: "#1F6757",
            }}
            fontColor="primary.main"
            fontWeight="700"
          />
          <OutlinedButton
            className="notosans"
            caption={t("draft_event")}
            onClick={() => handleDraft()}
            sx={{
              width: "170px",
              height: "34px",
              ml: "20px",
              my: "20px",
              color: "#57C0E7",
              borderColor: "#57C0E7",
            }}
            fontColor="#57C0E7"
            fontWeight="700"
          />
        </>
      ) : (
        <>
          {item?.status == EVENT_STATUS.DRAFT && (
            <OutlinedButton
              className="notosans"
              caption={t("draft_to_normal")}
              onClick={() => handleDraftPublic()}
              sx={{
                width: "170px",
                height: "34px",
                ml: "20px",
                my: "5px",
                color: "primaryMain",
                borderColor: "#1F6757",
              }}
              fontColor="primary.main"
              fontWeight="700"
            />
          )}
          <OutlinedButton
            className="notosans"
            caption={t("save_event")}
            onClick={() => handleSave()}
            sx={{
              width: "170px",
              height: "34px",
              ml: "20px",
              my: "5px",
              color: "primaryMain",
              borderColor: "#1F6757",
            }}
            fontColor="primary.main"
            fontWeight="700"
          />
          {item?.status !== EVENT_STATUS.DRAFT && item?.status !== EVENT_STATUS.ARCHIVED && (
            <OutlinedButton
              className="notosans"
              caption={item && item.isPublic ? t("private") : t("public")}
              onClick={() => {
                setType(EVENT_MODAL_TYPE.PUBLIC)
                setShowModal(true)
              }}
              sx={{
                width: "170px",
                height: "34px",
                ml: "20px",
                my: "5px",
                color: "#FFB800",
                borderColor: "#FFB800",
              }}
              fontColor="#FFB800"
              fontWeight="700"
            />
          )}
          {item?.status !== EVENT_STATUS.DRAFT && item?.status !== EVENT_STATUS.ARCHIVED && (
            <OutlinedButton
              className="notosans"
              caption={t("archive")}
              onClick={() => {
                setType(EVENT_MODAL_TYPE.ARCHIVE)
                setShowModal(true)
              }}
              sx={{
                width: "170px",
                height: "34px",
                ml: "20px",
                my: "5px",
                color: "#235496",
                borderColor: "#235496",
              }}
              fontColor="#235496"
              fontWeight="700"
            />
          )}
          <OutlinedButton
            className="notosans"
            caption={t("remove")}
            onClick={() => {
              setType(EVENT_MODAL_TYPE.REMOVE)
              setShowModal(true)
            }}
            sx={{
              width: "170px",
              height: "34px",
              ml: "20px",
              my: "5px",
              color: "#FC3317",
              borderColor: "#FC3317",
            }}
            fontColor="#FC3317"
            fontWeight="700"
          />
        </>
      )}
      <PublishModal
        item={item}
        type={type as number}
        open={showModal}
        handleOpen={setShowModal}
        handlePublic={handlePublic}
        handleArchive={handleArchive}
        handleRemove={handleRemove}
      />
    </Box>
  )
}
